import { render } from "./BasicSubtitle.vue?vue&type=template&id=41c805fc&scoped=true"
import script from "./BasicSubtitle.vue?vue&type=script&lang=js"
export * from "./BasicSubtitle.vue?vue&type=script&lang=js"

import "./BasicSubtitle.vue?vue&type=style&index=0&id=41c805fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-41c805fc"

export default script